import { render, staticRenderFns } from "./OffersProductItem.component.vue?vue&type=template&id=22deb3a0&scoped=true"
import script from "./OffersProductItem.component.vue?vue&type=script&lang=js"
export * from "./OffersProductItem.component.vue?vue&type=script&lang=js"
import style0 from "./OffersProductItem.component.vue?vue&type=style&index=0&id=22deb3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22deb3a0",
  null
  
)

export default component.exports